import React from 'react'
import RenderSpan from './RenderSpan'

const MailboxTypeCellNoEdit = ({ cell, row, rowIndex }) => {
  const selectedOptions = {
    0:   "None",
    1:   "User",
    2:   "Shared",
    3:   "Room",
    4:   "Equipment",
    99:  "NoData",
    100: "Unknown",
  }

  return (
    <span>
      <RenderSpan rowIndex={rowIndex} option={selectedOptions[cell]} ignoreReason={row.ignoreReason} />{' '}
    </span>
  )
}

export default MailboxTypeCellNoEdit
